module.exports = __webpack_public_path__ + "static/media/icon_info.9e3ffdeb.svg";